import React, { FC, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Menu from 'vibo-ui/Menu';
import Header from 'components/common/Header';
import Container from 'components/common/Container';

import { useMe } from 'graphql/hooks/user';
import { TEMPLATES_PAGE_MENU_ITEMS } from 'services/constants';
import { getSelectedTemplatesMenuKeys } from 'services/common/routesHelper';

import { TemplatesType } from 'types/enums';

const TemplatesPageHeader: FC<PropsWithChildren> = ({ children }) => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const { isChildDj } = useMe();

  return (
    <Header>
      <Container>
        <Menu
          getSelectedSidebarMenuKeys={getSelectedTemplatesMenuKeys}
          styleModificator="siderTop"
          mode="horizontal"
        >
          {TEMPLATES_PAGE_MENU_ITEMS.filter(
            ({ type }) => !(type === TemplatesType.company && !isChildDj)
          ).map(({ name, route }) => (
            <Menu.Item onClick={() => navigate(`/templates/${route}`)} key={route}>
              {t(name)}
            </Menu.Item>
          ))}
          <Menu.Item onClick={() => navigate(`/favorite-sections`)} key="/favorite-sections">
            {t('favoriteSections_plural')}
          </Menu.Item>
        </Menu>
        {children}
      </Container>
    </Header>
  );
};

export default TemplatesPageHeader;
